<div class="trip-detail-popup-right">
  <img
    src="assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form class="admin-forms" [formGroup]="doTruckOwnerForm">
  <div class="accordion-class">
    <h5>Edit Truck Owner DO</h5>
    <mat-divider></mat-divider>
  </div>

  <div class="input-fileds-container">
    <div class="group driver-truck">
      <div class="row align-items-center">
        <div class="col-sm-3">
          <div>Work Order No:</div>
        </div>
        <div class="col sm-3">
          <div class="details">{{ work_order.workOrderNo }}</div>
        </div>

        <div class="col-sm-3">
          <div>Actual Price Per Ton:</div>
        </div>
        <div class="col-sm-3">
          <div class="details">
            {{ work_order.actualPrice | number : "1.2-2" }}
          </div>
        </div>
      </div>
      <br />
      <div class="row mtb align-items-center">
        <div class="col-sm-3">
          <div>Work Order Date:</div>
        </div>
        <div class="col-sm-3">
          <div class="details">{{ work_order.workorderDate | date }}</div>
        </div>
        <div class="col-sm-3">
          <div>WO Qty :</div>
        </div>
        <div class="col-sm-3">
          <div class="details">
            {{ work_order.workorderqty | number : "1.3-3" }} Tons
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-sm-3">
          <div>Available Qty:</div>
        </div>
        <div class="col-sm-3">
          <div class="details">
            {{ work_order.availableqty | number : "1.3-3" }} Tons
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="row align-items-center">
    <mat-divider class="divider_mat"></mat-divider>
  </div>
  <br />
  <div class="row mtb align-items-center">
    <div class="col-sm-12">
      <h6>DO Details</h6>
    </div>
  </div>
  <form [formGroup]="doForm">
    <div class="row mtb align-items-center">
      <div class="col-sm-3">
        <mat-label>Do Issued Date:</mat-label>
      </div>
      <div class="col-sm-3">
        <mat-form-field>
          <mat-datepicker #picker1></mat-datepicker>
          <input
            class="details"
            matInput
            [matDatepicker]="picker1"
            [min]="minDate"
            formControlName="do_issue_date"
            (click)="picker1.open()"
          />
        </mat-form-field>
      </div>
      <div class="col-sm-2">
        <div class="Do_id">Do ID:</div>
      </div>
      <div class="col-sm-3">
        <div class="Do_id">{{ work_order.doInfo?.do_id }}</div>
      </div>
    </div>
    <div class="row mtb align-items-center">
      <div class="col-sm-3">
        <mat-label>Truck Owner Name:</mat-label>
      </div>
      <div class="col-sm-3">
        <mat-form-field>
          <input matInput class="details" formControlName="truckowner_id" />
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-label>Truck Owner Number:</mat-label>
      </div>
      <div class="col-sm-2">
        <mat-form-field>
          <input
            matInput
            class="details"
            formControlName="truckowner_number"
            required
          />
          <mat-error>Please Enter Truck Owner Number</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row mtb align-items-center">
      <div class="col-sm-3">
        <mat-label>Do Quantity:</mat-label>
      </div>
      <div class="col-sm-3">
        <mat-form-field>
          <input
            matInput
            class="details"
            formControlName="do_quantity"
            (focusout)="remainingQnty($event)"
            required
          />
          <mat-error>Please Enter Do quantity</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row mtb align-items-center">
      <div class="col-sm-3">
        <mat-label>Price Per Ton:</mat-label>
      </div>
      <div class="col-sm-3">
        <mat-form-field>
          <input
            matInput
            class="details"
            formControlName="price_per_ton"
            required
          />
          <mat-error>Please Enter Price Per Ton</mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-3">
        <mat-label>Sales Order Number:</mat-label>
      </div>
      <div class="col-sm-3">
        <mat-form-field>
          <input
            class="details"
            matInput
            formControlName="sales_order_no"
            placeholder="Enter Sales Order Number"
            readonly
            appAlphanumericOnly
            toUppercase
            maxlength="16"
          />
        </mat-form-field>
      </div>
    </div>

    <div class="row mtb">
      <div class="col-md-6 bill_details">
        <h6>Payment will be done as per:</h6>
      </div>
      <div class="col-md-6">
        <mat-radio-group
          aria-label="Select an option"
          formControlName="pay_as_load_quantity"
        >
          <mat-radio-button
            (change)="selectLoadedQty('loaded_quantity')"
            value="loaded_quantity"
            >Loaded Quantity</mat-radio-button
          >
          <mat-radio-button
            (change)="selectLoadedQty('unloaded_quantity')"
            value="unloaded_quantity"
            class="radio_btn"
            >Unloaded Quantity</mat-radio-button
          >
        </mat-radio-group>
      </div>
    </div>
    <div class="row btn_secton">
      <div class="col-sm-3">
        <button type="submit" class="button buttonBlue" (click)="updateTO()">
          Submit
        </button>
      </div>
    </div>
  </form>
</form>
